import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutPage: React.FC = () => {
    const navigate = useNavigate();

    const scrollToContact = () => {
        navigate('/eligibility');
    };

    return (
        <div className="bg-white min-h-screen pt-32 pb-20 font-sans text-slate-800">
            <div className="bg-[#011E26] text-white py-16 mb-16">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-serif mb-4">About Nex Overseas</h1>
                    <p className="text-xl text-slate-300 max-w-2xl">
                        Your trusted partner in global education and immigration.
                    </p>
                </div>
            </div>

            {/* About Content */}
            <section className="px-6 md:px-8 max-w-7xl mx-auto mb-20">
                <div className="max-w-4xl">
                    <span className="text-[#009B8F] font-bold tracking-widest text-xs uppercase mb-4 block">Who We Are</span>
                    <p className="text-lg leading-relaxed text-slate-600 mb-6">
                        Nex Overseas is an AI-driven global education and mobility platform designed to simplify and
                        strengthen every stage of a student’s international journey. We combine intelligent automation with
                        deep industry expertise to deliver fast, accurate, and personalised guidance that students can trust.
                    </p>
                    <p className="text-lg leading-relaxed text-slate-600 mb-6">
                        Our platform replaces outdated, advisor-dependent processes with technology that provides instant
                        clarity and structured pathways. From university selection and visa readiness to accommodation
                        matching and pre-arrival preparation, we support learners with tools that make international mobility
                        easier, more transparent, and more accessible.
                    </p>
                    <p className="text-lg leading-relaxed text-slate-600 mb-6">
                        We understand that studying or relocating abroad is a life-changing decision. That is why we focus on
                        delivering guidance that is reliable, unbiased, and grounded in verified information. Our AI-powered
                        systems analyse each student’s profile within seconds, offering tailored recommendations that help
                        them make informed choices with confidence.
                    </p>
                    <p className="text-lg leading-relaxed text-slate-600 mb-6">
                        While we provide comprehensive support for visa readiness and documentation preparation, we do
                        not offer legal advice. For matters requiring regulated immigration guidance, we connect students with
                        qualified and registered solicitors to ensure they receive the appropriate professional support.
                    </p>
                    <p className="text-lg leading-relaxed text-slate-600 mb-6">
                        Nex Overseas was created with a simple belief: global opportunities should be available to everyone,
                        not limited by geography, resources, or access to traditional advisors. By leveraging automation, we
                        remove barriers, reduce uncertainty, and create equal access to accurate information and
                        personalised support.
                    </p>
                    <p className="text-lg leading-relaxed text-slate-600 mb-6">
                        We are committed to building a smarter, more efficient future for international education — one where
                        technology empowers students to succeed, and every learner has a clear pathway to achieve their
                        goals abroad.
                    </p>

                    <button
                        onClick={scrollToContact}
                        className="bg-[#009B8F] text-white px-8 py-3 font-bold uppercase tracking-widest hover:bg-[#00857a] transition-colors rounded-sm shadow-lg mt-4"
                    >
                        Start Your Journey
                    </button>
                </div>
            </section>
        </div>
    );
};

export default AboutPage;
